import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    AccountService, DialogCloseReason, DialogService, IDialogHandle, IDialogOnClose, InlineMessageType, TitleFillStatus
} from '@clickd-angular/common-lib';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { EM1 } from '../../app.interfaces';
import {
    SegmentationMembersService, SegmentationMembersState
} from '../segmentation-members.service';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent implements OnInit, OnDestroy {
  clickListener : number = 0;
  columnName : string = null;
  ascOrDesc : string = null;
  pageSize: number = 20;
  accountKeyy: string = "atJrdi7f2EmJ0ZgoMyj97A";
  segmentId: string = "C31FB576-8311-ED11-B83D-0022481D679B"
  pageId: number = 1;
  totalElements: number = 0;
  offsetFirstItem: number = 0;
  offsetLastItem: number = 0;
  currentPageIndex: number = 0;
  totalPages: number = 0;
  maxRows: number = 0;
  maxPages: number = 0;
  selected: EM1["leads"];
  errorLogURL: string;

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  

  private storeSubscription: Subscription;
  connectorsList$: Observable<EM1["leads"]>;
  connectorsAreLoading$: Observable<boolean>;

  TitleFillStatus = TitleFillStatus;
  InlineMessageType = InlineMessageType;
  isMessageShown: boolean;
  isSuccess: boolean;
  isCreate: boolean;
  isUpdate: boolean;
  connectorName: string;
  connectorType: string;
  isReInitRequired: boolean;
  existingConnectors: EM1["leads"];

  

  constructor(
    public emService: SegmentationMembersService,
    private router: Router,
    private rout: ActivatedRoute,
    private accountService: AccountService,
    private dialogService: DialogService,
    private translate: TranslateService,
    private route: ActivatedRoute
  ) {
    this.storeSubscription = emService.state$.subscribe();
    this.connectorsList$ = this.emService.state$.pipe(
      map((state: SegmentationMembersState) => {
        if (state.connectors) {
          this.totalElements = state.totalElements;
          this.calculateItemOffsets();

          state.connectors.forEach((i) => {
            i.updated = i.updated
              ? new Date(i.updated).toLocaleDateString()
              : '';
            i.createdOn = i.createdOn
              ? new Date(i.createdOn).toLocaleDateString()
              : '';
          });
        }
        this.existingConnectors = state.connectors;

        return state.connectors;
      })
    );

    this.connectorsAreLoading$ = this.emService.state$.pipe(
      map((state: SegmentationMembersState) => {
        return state.isLoadingConnectors;
      })
    );

    if (this.pageSize > 0) {
      this.totalPages = Math.floor(this.totalElements / this.pageSize);
    } else {
      this.totalPages = 0;
    }
    this.selected = [];

    rout.queryParams.subscribe((queryParam) => {
      this.connectorType = queryParam.connectorType;
      this.connectorName = queryParam.connectorName;

      if (queryParam.connectorName && queryParam.connectorType) {
        this.isCreate = true;
        this.isSuccess = true;
        this.isMessageShown = true;
      }
      if (!this.accountService.accountKey) {
        this.accountService.accountKey = queryParam.accountKey;
      }
    });

    const extras = this.router.getCurrentNavigation().extras.state;
    if (extras) {
      this.isMessageShown = extras.isMessageShown;
      this.isSuccess = extras.isSuccess;
      this.isCreate = extras.isCreate;
      this.isUpdate = extras.isUpdate;
      this.connectorName = extras.connectorName;
      this.connectorType = extras.connectorType;
      this.isReInitRequired = extras.isReInitRequired;

      if (!this.accountService.accountKey) {
        this.accountService.accountKey = extras.accountKey;
      }
    }
  }

  ngOnInit(): void {
    //this.accountKeyy = this.route.snapshot.queryParamMap.get('accountKey');
    //this.segmentId = this.route.snapshot.queryParamMap.get('segmentId');
    this.emService.getConnectors(this.accountKeyy, this.segmentId, this.pageSize, this.pageId,this.columnName, this.ascOrDesc);
  }

  get selectedCount(): number {
    if (!this.selected) {
      return 0;
    }
    return this.selected.length;
  }

  singleSelectCheck(row: any) {
    return this.selected.indexOf(row) === -1;
  }



  cantPageBackward(): boolean {
    return this.currentPageIndex === 0;
  }

  cantPageForward(): boolean {
    return this.currentPageIndex + 1 === this.totalPages;
  }

  pageToFirst() {
    this.currentPageIndex = 0;
    this.pageId = 1;
    this.emService.getConnectors(this.accountKeyy,this.segmentId, this.pageSize, this.pageId, this.columnName, this.ascOrDesc);
    this.calculateItemOffsets();
  }

  pageBackward() {
    this.currentPageIndex--;
    this.emService.getConnectors(this.accountKeyy,this.segmentId, this.pageSize, --this.pageId, this.columnName, this.ascOrDesc);
    this.calculateItemOffsets();
  }

  pageForwardToNext() {
    this.currentPageIndex++;
    this.emService.getConnectors(this.accountKeyy,this.segmentId, this.pageSize, ++this.pageId ,this.columnName, this.ascOrDesc);
    this.calculateItemOffsets();
  }

  pageToLast() {
    this.currentPageIndex = this.totalPages - 1;
    this.pageId = this.totalPages;
    this.emService.getConnectors(this.accountKeyy,this.segmentId, this.pageSize, this.pageId, this.columnName, this.ascOrDesc);
    this.calculateItemOffsets();
  }

  private calculateItemOffsets() {
    if (this.totalElements > 0 && this.pageSize > 0) {
      this.offsetFirstItem = this.currentPageIndex * this.pageSize + 1;
      const maxRows = Math.max(this.totalElements, 1);
      const offsetLastItems = (this.currentPageIndex + 1) * this.pageSize;
      this.offsetLastItem = Math.min(offsetLastItems, this.totalElements);
      this.totalPages = Math.ceil(maxRows / this.pageSize);
    }
  }
  setOrderBy(name: string) {
    this.clickListener ++;
    if(this.columnName != name){
      this.clickListener = 0;
    }
    if(this.clickListener %2==0 || this.clickListener == 0){
       this.ascOrDesc = 'ASC';
    }else{
      this.ascOrDesc = 'DESC';
    }

    this.columnName = name;
   // console.log(this.columnName + "  "+ this.clickListener + "  "+ this.ascOrDesc);
    this.emService.getConnectors(this.accountKeyy,this.segmentId, this.pageSize, this.pageId, this.columnName, this.ascOrDesc);
    //refresh page 
  }

  refreshPage() {
    this.emService.getConnectors(this.accountKeyy,this.segmentId, this.pageSize, this.pageId, this.columnName, this.ascOrDesc);
  }

  ngOnDestroy(): void {
    this.storeSubscription.unsubscribe();
  }
}
